export class UserSetInfoPriorToLoginResultDto {
    ok = false;
    message: string;
    newUserName: string;
}
